import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useFeedInternalContext } from "@/contexts/feed-context";
import { PostsOrderBy } from "@/graphql/codegen/graphql";

export const UserFeedSortDropdown = () => {
  const { postOrderBy, setPostOrderBy } = useFeedInternalContext();

  const onSortChange = (value: PostsOrderBy) => {
    setPostOrderBy(value);
  };

  return (
    <div className="flex items-center">
      <Select onValueChange={onSortChange} value={postOrderBy}>
        <SelectTrigger
          className="
            rounded-none border-none bg-transparent px-4 py-2 leading-none
            text-muted hover:border-transparent focus:ring-0
          "
        >
          <span
            className="
              text-xs underline-offset-4
              hover:underline
            "
          >
            <SelectValue
              placeholder={PostsOrderBy.UpvoteWealthUsdCentsDesc}
              className="text-xs"
            />
          </span>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={PostsOrderBy.UpvoteWealthUsdCentsDesc}>
            Hot
          </SelectItem>
          <SelectItem value={PostsOrderBy.TimestampDesc}>Latest</SelectItem>
          {/* TODO probably we can apply this sorts */}
          {/* <SelectItem value="3">Most viewed</SelectItem>
          <SelectItem value="4">Most engagements</SelectItem>
          <SelectItem value="5">Most replies</SelectItem>
          <SelectItem value="6">Most reposts</SelectItem>
          <SelectItem value="7">Highest tip</SelectItem>
          <SelectItem value="8">View wealth</SelectItem>
          <SelectItem value="9">Engagement wealth</SelectItem> */}
        </SelectContent>
      </Select>
    </div>
  );
};
